import { SvgIcon } from '@mui/material';

const BagageIcon = () => {
  return (
    <SvgIcon width="18" height="24" viewBox="0 0 18 24">
      <g id="fa6-solid:suitcase-rolling" clipPath="url(#clip0_5318_138799)">
        <path
          id="Vector"
          d={`M6.56156 2.55172C6.56156 2.35123 6.7256 2.18719 6.92609 2.18719H10.5714C10.7719 2.18719 10.9359 2.35123
          10.9359 2.55172V5.8325H6.56156V2.55172ZM14.5813 5.8325H13.1231V2.55172C13.1231 1.14372 11.9794 0 10.5714
          0H6.92609C5.51809 0 4.37437 1.14372 4.37437 2.55172V5.8325H2.91625C1.30776 5.8325 0 7.14026 0
          8.74875V18.9556C0 20.5641 1.30776 21.8719 2.91625 21.8719C2.91625 22.6784 3.56785 23.33 4.37437 23.33C5.1809
          23.33 5.8325 22.6784 5.8325 21.8719H11.665C11.665 22.6784 12.3166 23.33 13.1231 23.33C13.9297 23.33 14.5813
          22.6784 14.5813 21.8719C16.1897 21.8719 17.4975 20.5641 17.4975 18.9556V8.74875C17.4975 7.14026 16.1897
          5.8325 14.5813 5.8325ZM5.10344 10.2069H12.3941C12.795 10.2069 13.1231 10.535 13.1231 10.9359C13.1231 11.3369
          12.795 11.665 12.3941 11.665H5.10344C4.70245 11.665 4.37437 11.3369 4.37437 10.9359C4.37437 10.535 4.70245
          10.2069 5.10344 10.2069ZM5.10344 16.0394H12.3941C12.795 16.0394 13.1231 16.3675 13.1231 16.7684C13.1231
          17.1694 12.795 17.4975 12.3941 17.4975H5.10344C4.70245 17.4975 4.37437 17.1694 4.37437 16.7684C4.37437
          16.3675 4.70245 16.0394 5.10344 16.0394Z`}
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_5318_138799">
          <rect width="17.4975" height="23.33" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default BagageIcon;
